const Footer = () => {

    return (
        <footer className="">
            <div className="custom-screen flex justify-center">
                <div className="mt-10 py-8 border-t border-gray-800 items-center justify-between sm:flex">
                    <p className="text-gray-400 text-center">Do it with Ease</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer